import type { LocationQuery } from 'vue-router'

import { parseArrayParam, parseStringParam } from '@helpers/query-params'

export interface DisciplineTaskCommentsFilterParams {
  discipline_id: string[]
  created_from: string | null
  created_to: string | null
}

export const parseFilterParams = (query: LocationQuery): DisciplineTaskCommentsFilterParams => {
  return {
    discipline_id: parseArrayParam(query, 'discipline_id'),
    created_from: parseStringParam(query, 'created_from'),
    created_to: parseStringParam(query, 'created_to'),
  }
}

export const buildQueryObject = (params: DisciplineTaskCommentsFilterParams): Record<string, string> => {
  const query: Record<string, string> = {}

  if (params.created_from) query.created_from = params.created_from
  if (params.created_to) query.created_to = params.created_to

  params.discipline_id.forEach((v, i) => { query[`discipline_id[${i}]`] = v })

  return query
}